import countryCallingCode from "../../data/countries.json";

export default function CallCodeInput({ callCode, setCallCode, disabled }) {
  return (
    <div className="relative text-gray-4 text-sm">
      <label htmlFor="country-call-code" hidden>
        country calling code
      </label>
      <select
        id="country-call-code"
        name="country-call-code"
        className="absolute w-full h-full opacity-0 disabled:bg-gray-2 cursor-pointer"
        disabled={disabled}
        value={callCode || ""}
        onChange={(event) => setCallCode(event.target.value)}
        tabIndex="-1"
      >
        <option value="" disabled></option>
        {countryCallingCode.map((countryObj) => (
          <option
            value={`${countryObj.isoCode}/${countryObj.dialCode}`}
            key={countryObj.isoCode}
          >
            {countryObj.name} {countryObj.dialCode}
          </option>
        ))}
      </select>
      <div
        className="h-full flex items-center min-w-[40px] px-3 justify-center"
        aria-hidden="true"
      >
        {disabled ? callCode : callCode && callCode.split("/")[1]}
      </div>
    </div>
  );
}
